import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import avatar from '../../Pics/avatar.jpg'

import SpecificComponent from '../SpecificComponent'
import { Fab, FormControl, InputLabel, Select, MenuItem, Input, Grid, Checkbox, Divider } from '@material-ui/core';
import Utils from '../../providers/Utils';
import PropTypes from 'prop-types';
import Ws from '../../providers/Ws';
import OpenAddFisaPostului from './OpenAddFisaPostului';
import OpenAddCV from './OpenAddCV';
import ListTimpiLucru from '../ListTimpiLucru';
import FromServer from '../../module/projects/FromServer';
import DocumenteList from '../DocumenteList';
import AlertDialog from './AlertDialog';




export default class TaskuriDocumente extends SpecificComponent {

    constructor(props) {
        super(props)
        this.state = {
            fullScreen:false
            
          
        }
    }


    componentDidMount(){
        this.getWindowDimentions()
    }

    getWindowDimentions = () => {
        let windowWidth = window.innerWidth


        this.setState({
            fullScreen: windowWidth <= 800 ? true : false
        })

    }

    selectTaskFile = (id) => {
        //  console.log('Incepe poza');
        let pi = document.getElementById(id);

        pi.click()
    }

       uploadTaskDoc =async (id, idTask) =>{
        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);
  
        reader.onload = async () => {
            let fileContent = reader.result;
            // console.log(fileContent);
            // console.log('saveFile :', saveFile);
  
  
            let uploadImage = await ws.uploadimage('Upload/DocTask' ,saveFile, idTask, this.props.idProiect);

            // console.log('uploadImage :', uploadImage);
            if(uploadImage.Succes){
             this.props.getTaskData()
            }
            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);
  
        }
       }

       goToFile = (f) =>{
        let adresaFisa = new Ws().adresaMedia + `/Taskuri/Docs/${f.token}`

        window.open(adresaFisa)
    }

    



  
    render() {
        return (
            <div>
                <Dialog
                    open={this.props.open}
                    onClose={this.props.dialogClose}
                    fullWidth={true}
                    maxWidth={'md'}
                    fullScreen={this.state.fullScreen}
                    style={{
                        zIndex: 5100,
                    }}
                >

                    <DialogActions>
                        <Fab onClick={this.props.dialogClose} className="pm-round-button-dialog">
                            <i className='material-icons pm-round-button-text-dialog'>clear</i>
                        </Fab>
                    </DialogActions>
                    
                <div style={{marginBottom:20}}> 
                    <div 
                    
                onClick={()=>{this.selectTaskFile('fileTask')}}
                className='container'>
                    <h1 className='pm-title'>{this.props.dictionary.proiecte.etapeProiect.documenteTask}</h1>
                    <div  style={{position:this.state.fullScreen ? '' : 'absolute', top:0, right:30, cursor:'pointer', textAlign:'center'}}>
                    <i style={{ display:'block',fontSize:40, color:'#6f9ce2'}} className='material-icons'>cloud_upload</i>
                    <span className='pm-title'>{this.props.dictionary.proiecte.informatiiProiect.upload}</span>

                    <input type='file' id={`fileTask`}
                                                              style={{display:'none'}}
                                                              accept='.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .pdf'
                                             onChange={()=>{this.uploadTaskDoc(`fileTask`, this.props.idtask)}} />  

                    </div>
                    </div>
                    <Divider className='pm-divider' />
                   
                    <DocumenteList
                    style={{textAlign:'center'}}
                    elemente={this.props.listDocumente}
                    dict={this.dictionary}
                    onlyColumns={{ nume: 'nume', data: 'cand_uploadat', doc_info:'doc_info'}}
                    
                    goToFile={this.goToFile}
                    deleteFile={this.props.deleteFile}
                        />

                        <AlertDialog
                            open={this.props.isOpenAlert}
                            dialogClose={this.props.dialogCloseAlert}
                            title={this.props.dictionary.alertDate.document}
                            limba={this.props.dictionary}
                            yesFunction={this.props.deleteDoc}/>
                </div>   
                </Dialog>



           



            </div>

        );
    }


}  // end class

TaskuriDocumente.propTypes={
    open:PropTypes.bool,
    dialogClose:PropTypes.func,
    idProiect:PropTypes.string,
    getTaskData:PropTypes.func,
    uploadTaskDoc:PropTypes.func,
    idtask:PropTypes.number,
    listDocumente:PropTypes.array,
    deleteFile:PropTypes.func,
    isOpenAlert:PropTypes.bool,
    dialogCloseAlert:PropTypes.func,
    deleteDoc:PropTypes.func
    

}